module.exports = __webpack_public_path__ + "img/battery-good-symbolic.9ce48685.svg";